import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const user = JSON.parse(localStorage.getItem('user_data') || 'null');

  // ✅ User logged in
  if (user) {
    // Logged-in user signin/login page ki vellakudadhu
    if (state.url === '/signin' || state.url === '/login') {
      router.navigate(['/home'], { replaceUrl: true });
      return false;
    }
    return true;
  }

  // ❌ User NOT logged in → secured pages ki allow cheyyoddu
  if (state.url !== '/signin' && state.url !== '/login') {
    router.navigate(['/signin'], { replaceUrl: true });
    return false;
  }

  return true;
};
